"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createKidneyDiseaseEthiology = createKidneyDiseaseEthiology;
const utils_1 = require("../../../events/utils");
const kidneyDiseaseEthiology_1 = require("../../../forms/ktx/basic-registration-data/waiting-list-data/kidneyDiseaseEthiology");
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    title: {
        id: "ktx.dashboard.kidney_disease_ethiology",
        defaultMessage: "Vesebetegség diagnózisa"
    }
};
function createKidneyDiseaseEthiology(intl, options) {
    const lists = createList(intl, options);
    const content = (0, shared_1.createGroupContent)(lists);
    return (0, shared_1.createGroup)(intl, { label: messages.title, content });
}
function createList({ formatMessageMap, formatDate }, { events }) {
    const relevantEvents = (0, utils_1.findEventsByQuery)(events, queries_1.waitingListQueries.kidneyDiseaseEthiology);
    return relevantEvents
        .map(event => {
        const { timestamp, origin } = event;
        const formattedTimestamp = formatDate(timestamp, {
            year: "numeric",
            month: "numeric",
            day: "numeric"
        });
        let formattedMessage;
        const inc = Object.keys(kidneyDiseaseEthiology_1.diagnosisBaselineDiseaseMessages).includes(event.value.diagnosisBaselineDisease);
        if (!inc) {
            formattedMessage = event.value.diagnosisBaselineDisease;
        }
        else {
            formattedMessage = formatMessageMap(kidneyDiseaseEthiology_1.diagnosisBaselineDiseaseMessages, event.value.diagnosisBaselineDisease);
        }
        const items = [];
        items.push({
            type: "list-item",
            value: formattedMessage
        });
        return {
            type: "list",
            attachments: (0, utils_1.mapEventsToAttachments)(event),
            timestamp: event.timestamp,
            label: formattedTimestamp,
            origin,
            items
        };
    })
        .sort(shared_1.compareByTimestamp);
}
